import styled from 'styled-components'
import { Checkbox, FormControlLabel } from '@material-ui/core'

export const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiTypography-body1 {
    font-size: 0.875rem;
  }
`

export const StyledCheckbox = styled(Checkbox)``
